import { useLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { omaElisaForCompaniesMsg, quotesMsg, t } from '../../../../../common/i18n/index.js';
import { BreadCrumbsWithTitle } from '../../../../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle.js';
import { QuoteDetailsCoCo } from '../../../../../components/Quote/QuoteDetailsCoCo.js';

export const QuotePathCoCo = () => {
  const proposal = useLoaderData();

  const breadCrumbs = (
    <BreadCrumbsWithTitle
      breadCrumbPaths={[
        { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
        { name: t.J63R(quotesMsg), path: paths.PS_QUOTES },
        { name: proposal.name || '' },
      ]}
    />
  );

  return <QuoteDetailsCoCo breadCrumbs={breadCrumbs} proposal={proposal}></QuoteDetailsCoCo>;
};
